import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-text',
  templateUrl: './report-text.component.html',
  styleUrl: './report-text.component.scss',
})
export class ReportTextComponent {
  @Input() textCenter: boolean;
  @Input() textRight: boolean;
}
